export default function gf (Vue) {
  Vue.prototype.actionAuth = function (action) {
    return true
  }
}
